import { render, staticRenderFns } from "./JudgePost.vue?vue&type=template&id=62e537c1&"
import script from "./JudgePost.vue?vue&type=script&lang=js&"
export * from "./JudgePost.vue?vue&type=script&lang=js&"
import style0 from "./JudgePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports